module.exports = "<div class=\"container\">\n  <h1>Parece que estas perdido</h1>\n  <h3>Error 404</h3>\n  <img src=\"assets/img/astronaut.png\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main